import { Component, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { ServiceService } from '../service.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-factory-projection',
  templateUrl: './factory-projection.component.html',
  styleUrls: ['./factory-projection.component.css']
})
export class FactoryProjectionComponent implements OnInit {
  body =
    {
      year_month: '',
      created_by_id: null,
      factory_projection_array: []
    }
  data: any = []
  productPrice: any = []
  tableBol = false
  ResultBol = false
  factory_projection_array: any = []
  Failed_category: any = []
  Failed_Intermediate: any = []
  isShow = false
  loaderShown = false
  constructor(private apiService: ServiceService, private router: Router) {
    const date = new Date();
    const month = ('0' + (date.getMonth() + 1)).slice(-2); // Ensures two digits
    const year = date.getFullYear();
    const nowdate = `${year}-${month}`;
    this.body.year_month = nowdate;
  }

  ngOnInit(): void {


  }

  onFileChange(evt: any) {
    this.loaderShown = true
    /* wire up file reader */
    this.isShow = true
    this.tableBol = false
    this.productPrice = []
    this.factory_projection_array = []
    this.Failed_category = []
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.data = <any[][]>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      console.log("data:", this.data);
      const promises = this.data.map((res: any[], index: number) => {
        // Check if it's not the first object (index > 0)
        if (index > 0) {
          let obj = {
            material_id: '',
            material_name: res[0],
            uom: res[1] || '',
            in_liter: res[2] || 0,
            approved_quantity: res[3] || 0,
            per_can_qty_in_kg: res[4] || 0,
            intermediate_material: '',
            intermediate_material_id: '',
            total_req_intermediate: res[6] || 0
          };
          if (res[0] == undefined) {
            res[0] = ''
          }
          let match = {
            product_name: res[0]
          }
          const productMatch = this.apiService.productMatch(match).toPromise()

          const intermediateMatch = this.apiService.interProductMatch(res[5]).toPromise()

          return Promise.all([productMatch, intermediateMatch]).then(([result, result2]) => {
            if (result.success) {
              obj.material_id = result.data[0].product_id
              this.factory_projection_array.push(obj);
              if (result2.data.length != 0) {
                obj.intermediate_material_id = result2.data[0].product_id
                obj.intermediate_material = res[5]
              } else {
                obj.intermediate_material_id = ''
                obj.intermediate_material = ''
                if (res[5] != undefined) {
                  this.Failed_Intermediate.push(res[5])
                }
              }
            } else {
              this.Failed_category.push(obj);
            }
            if (result2.success) {

              // Process result2 if needed, otherwise ignore if it's the same API call
            } else {
              // Handle failure for the second call if necessary
            }
          })
          // return this.apiService.productMatch(match).toPromise().then((result) => {
          //   if (result.success) {
          //     obj.material_id = result.data[0].product_id
          //     this.factory_projection_array.push(obj);
          //   } else {
          //     this.Failed_category.push(obj);
          //   }
          // });
        }
        return Promise.resolve();
      });

      // Wait for all API calls to complete
      Promise.all(promises).then(() => {
        console.log("Transformed Object:", this.factory_projection_array);
        console.log("failed Object:", this.Failed_category);
        this.isShow = false;
        this.loaderShown = false
        this.tableBol = true;

        if (this.Failed_category.length > 0) {
          $('#product-failed-modal').modal({
            backdrop: false
          });
          $('#product-failed-modal').modal('show')
        }
        // if (this.Failed_Intermediate.length > 0) {
        //   $('#inter-failed-modal').modal({
        //     backdrop: false
        //   });
        //   $('#inter-failed-modal').modal('show')
        // }


      }).catch((error) => {
        console.error("Error checking :", error);
        alert("Time out try again")
        this.isShow = false;
      });
    };
    reader.readAsBinaryString(target.files[0]);
  }

  submit() {

    this.body.factory_projection_array = this.factory_projection_array
    console.log('body', this.body)
    try {
      var created_id: any
      created_id = localStorage.getItem('admin_id')
      this.body.created_by_id = created_id
    } catch (error) {
      alert("User Id not found")
    }

    // return
    this.apiService.factoryExcelUpload(this.body).subscribe((res) => {
      console.log("response", res)
      if (res.success) {
        this.router.navigate(['admin/factory-projection-listing']);
        this.apiService.showToast('success', 'successfully added')
      }
      else {
        this.apiService.showToast('error', res.message)
        // alert(res.message)
      }
    })
  }



}
